var exports = {
  "DD": "RecoverAccountPage.module__title___bkJQZW",
  "h_": "RecoverAccountPage.module__description___bkJQZW",
  "Zd": "RecoverAccountPage.module__form___bkJQZW",
  "qr": "RecoverAccountPage.module__footer___bkJQZW",
  "zc": "RecoverAccountPage.module__formError___bkJQZW",
  "iS": "RecoverAccountPage.module__keyInput___bkJQZW",
  "aK": "RecoverAccountPage.module__hint___bkJQZW",
  "nf": "RecoverAccountPage.module__link___bkJQZW",
};

module.exports = exports;
